var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAssetsHeavyTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_assets_heavy_truck",
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.478,
    height: 46.476,
    viewBox: "0 0 82.478 46.476",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M25.333,26.256H22.7a.086.086,0,0,1-.086-.086V24.821c0-1.83,2.17-2,4.916-2.208h0c.9-.069,2.539-.1,4.885-.1,3.1,0,6.635.061,8.1.09V14.515c0-2.043.834-3.037,2.553-3.037h3.586a19,19,0,0,1,3.258-5.525A16.623,16.623,0,0,1,63.045,0c1.535,0,2.374.214,2.893.737a3.2,3.2,0,0,1,.581,2.455c0,.127,0,.258,0,.4V28.353h36.012a.6.6,0,0,1,.6.6v2.525a.6.6,0,0,1-.6.6H92.863a3.617,3.617,0,0,0-2.472,3.529.6.6,0,0,1-1.2,0c0-2.643-2.847-3.087-3.161-3.127H74.45c-.576.252-3.228,1.732-3.228,7.4a.6.6,0,0,1-.6.6H45.6A.6.6,0,0,1,45,39.9,11.9,11.9,0,0,0,43.7,35.331c-1.582-2.995-4.264-4.513-7.974-4.513a8.428,8.428,0,0,0-8.025,4.647,13,13,0,0,0-1.374,4.777.6.6,0,0,1-.6.575H23.219a.6.6,0,0,1-.6-.6v-10.6a.086.086,0,0,1,.086-.086h2.631a1.635,1.635,0,1,0,0-3.271M51.593,14.94H45.075A1.163,1.163,0,0,0,43.913,16.1h0v6.518h7.681Zm9.934,10.477,4.147,4.812a.447.447,0,0,0,.7,0,.64.64,0,0,0,0-.81l-4.436-5.147H24.708a.579.579,0,0,0,0,1.146Z",
    transform: "translate(-22.616)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_39",
    "data-name": "Group 39",
    transform: "translate(68.575 32.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M-9662.873-274.171a6.709,6.709,0,0,1-6.7-6.7,6.71,6.71,0,0,1,6.7-6.7,6.709,6.709,0,0,1,6.7,6.7A6.708,6.708,0,0,1-9662.873-274.171Zm-.3-10.4a4,4,0,0,0-4,4,4,4,0,0,0,4,4,4,4,0,0,0,4-4A4.006,4.006,0,0,0-9663.174-284.574Z",
    transform: "translate(9669.575 287.574)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41",
    "data-name": "Group 41",
    transform: "translate(6.575 32.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_7",
    "data-name": "Subtraction 7",
    d: "M-9600.873-274.171a6.709,6.709,0,0,1-6.7-6.7,6.709,6.709,0,0,1,6.7-6.7,6.708,6.708,0,0,1,6.7,6.7A6.708,6.708,0,0,1-9600.873-274.171Zm-.3-10.4a4,4,0,0,0-4,4,4,4,0,0,0,4,4,4,4,0,0,0,4-4A4,4,0,0,0-9601.172-284.573Z",
    transform: "translate(9607.575 287.573)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40",
    "data-name": "Group 40",
    transform: "translate(51.575 32.573)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M-9645.875-274.171a6.708,6.708,0,0,1-6.7-6.7,6.708,6.708,0,0,1,6.7-6.7,6.709,6.709,0,0,1,6.7,6.7A6.709,6.709,0,0,1-9645.875-274.171Zm-.3-10.4a4,4,0,0,0-4,4,4,4,0,0,0,4,4,4,4,0,0,0,4-4A4,4,0,0,0-9646.173-284.573Z",
    transform: "translate(9652.575 287.573)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAssetsHeavyTruck);
export default __webpack_public_path__ + "static/media/icon_assets_heavy_truck.c86c40ad44dedb49822ae0bf849faacc.svg";
export { ForwardRef as ReactComponent };